import React, { useState, useRef } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import Swal from 'sweetalert2';
import { useUIUtils } from 'hooks/useUIUtils';
import { useForm } from 'react-hook-form';
import { currency } from 'resources/utilities';
import { Link, StepLabel, Stepper, Step } from '@mui/material';
import SLUGS from 'resources/slugs';
import sinImagen from 'images/venta/SIN-IMAGEN.jpg'
import TituloPagina from 'components/header/TituloPagina';
import { descargarFactura } from 'actions/archivos'
import { useSurtirRemision } from './SurtirRemision/SurtirRemision';

const View = ({ history, match, saludo, subtitulo }) => {
    const { changeGlobalTitle } = useUIUtils()
    const { id } = match.params;
    const { document } = match.params;
    const { handleSubmit } = useForm();
    let [, setDocumento] = useState(document);
    let [TipoDocto, setTipoDocto] = useState('C');
    let [Docto, setDocto] = useState('C');
    const isAddMode = !id;
    let [cliente, setCliente] = useState([]);
    let [direcciones, setDirecciones] = useState([]);
    let [load, setLoad] = useState(false);
    let [venta, setVenta] = useState({
        id: 0,
        empresa_Id: getDataSession('empresa'),
        sucursal_Id: getDataSession('sucursal'),
        cliente_Id: 0,
        direccion_Id: 0,
        no_Orden: '',
        folio: '',
        moneda: 'MXN',
        descuento_Importe: 0,
        estatus: 'P',
        importe_Total_Impuestos: 0,
        metodo_Pago: '',
        clave_Envio: '',
        forma_De_Pago: '',
        tipo_Documento: TipoDocto,
        descripcion: ''
    });
    const [, setError] = useState(['']);
    let [, setErroresCliente] = useState({});
    let [ventaDetalles, setVentaDetalles] = useState([]);
    let [, setErroresDirecciones] = useState({});
    let [, setSucursales] = useState([]);
    let [, setSeries] = useState([]);
    const [, setSatFormaPago] = useState(['']);
    const [, setSatPais] = useState(['']);
    let [, setErroresV] = useState({});
    // var direccion_id = 0;
    const [facturado, setFacturado] = useState(false);
    const ventaSucursalIdRef = useRef(venta.sucursal_Id);

    React.useEffect(() => {
        console.log("entro efect");
        setDocumento(match.params.documento);
        //console.log(match.params.documento);
        switch (match.params.documento) {
            case 'remisiones':
                setTipoDocto('R');
                setDocto('Remisión');
                changeGlobalTitle('Remisión');
                break;
            case 'cotizaciones':
                setTipoDocto('C');
                setDocto('Cotización');
                changeGlobalTitle('Cotización');
                break;
            case 'pedidos':
                setTipoDocto('P');
                setDocto('Pedido');
                changeGlobalTitle('Pedido');
                break;
            default:
                setTipoDocto('P');
                setDocto('Pedido');
                changeGlobalTitle('Pedido');
                break;
        }
    }, [match.params.documento, changeGlobalTitle]);

    async function getSatFormaPago() {
        const response = await fetchConToken(`CatalogosSat/ListFormaPago?pagina=1&totalXpagina=300`);
        setSatFormaPago(response);
    }

    async function getSatPais() {
        const response = await fetchConToken(`CatalogosSat/ListPais?pagina=1&totalXpagina=300`);
        setSatPais(response);
    }

    async function getSucursales() {
        const response = await fetchConToken(`Sucursales/GetList?empresa_id=${getDataSession('empresa')}&pagina=1&totalXpagina=50`);
        setSucursales(response);
    }

    if (getDataSession('sucursal') === '0') {
        Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
    }

    async function getSeries(sucursal_id) {
        const response = await fetchConToken(`Sucursales/GetFoliosSucursales?sucursal_Id=${sucursal_id}&tipo_Documento=F`);
        setSeries(response);
    }

    const cancelar = () => {
        Swal.fire({
            title: 'Cancelación',
            text: "Desea cancelar la venta",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Cancelar!',
            cancelButtonText: 'No!'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchConToken(
                    `Ventas/Cancelar?documento_id=${id}&sucursal_id=${getDataSession('sucursal')}`,
                    null, 'POST'
                ).then((response) => {
                    setErroresV({});
                    if (response.hasOwnProperty('status') && response.status === 400) {
                        Object.entries(response.errors).forEach(([, value]) => {
                            Swal.fire('Error', value[0], 'error');
                        });
                        return false;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return false;
                    }

                    Swal.fire('Exito', Docto + ' cancelada', 'success');
                    venta.id > 0 ? history.push('..') : history.push('.');
                    return true;
                });
            }
        });
    }

    ///////////////////////////////////////////
    /*
        const saveArticulos = () => {
            setErroresArticulos({});
            setError('');
            ventaDetalles.map((art) => {
                art.articulo.descripcion =
                    art.articulo.descripcion.replace(' ') === ' ' ? '' : art.articulo.descripcion;
                fetchConToken(
                    `Articulos?sucursal_Id=${getDataSession('sucursal')}`,
                    art.articulo,
                    'PUT'
                ).then((response) => {
                    if (response.hasOwnProperty('status')) {
                        Object.entries(response.errors).forEach(([ , value]) => {
                            Swal.fire('Error', value[0] + ' Clave: ' + art.articulo.clave, 'error');
                        });
                        setError('Revisar errores');
                        return false;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return false;
                    }
                });
                return true;
                //.catch(alertService.error("153"));
            });
    
            if (Object.entries(erroresArticulos).length > 0) return false;
            if (erroresArticulos[0] !== undefined) return false;
    
            return true;
        };*/


    const saveCliente = () => {
        cliente.empresa_Id = getDataSession('empresa');
        cliente.sucursal_Id = getDataSession('sucursal');
        if (!cliente.hasOwnProperty('uso_Cfdi')) cliente.uso_Cfdi = 'G01';

        if (!cliente.hasOwnProperty('regimen_Fiscal_Receptor')) cliente.regimen_Fiscal_Receptor = '601';

        if (!cliente.hasOwnProperty('no_Cliente')) cliente.no_Cliente = 'local';

        cliente.sucursal_Id = getDataSession('sucursal');
        fetchConToken(
            `Clientes?sucursal_Id=${getDataSession('sucursal')}`,
            cliente,
            cliente.hasOwnProperty('id') && cliente.id !== null ? 'PUT' : 'POST'
        ).then((response) => {
            setError(['']);
            setErroresV({});
            setErroresCliente('');
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');
                });
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            setCliente([]);
            setCliente(response);
            saveDireccion(response.id);

            return true;
        });
        return true;
        //.catch(alertService.error("91"));
    };

    const DescargarGuia = () => {
        setLoad(true);
        fetchConToken(`Ventas/DescargarEtiquetaEnvio?venta_id=${id}`).then(async (responseFile) => {
            try {
                if (responseFile.hasOwnProperty('status') && responseFile.status === 400) {
                    Object.entries(responseFile.errors).forEach(([, value]) => {
                        Swal.fire('Error', value[0], 'error');
                    });
                    return false;
                } else if (responseFile.hasOwnProperty('codigo') && responseFile.codigo !== 200) {
                    Swal.fire('Error', responseFile.mensajes[0], 'error');
                    return false;
                }

                var win = window.open(responseFile.guiaEnvio, '_blank');
                win.focus();
                setLoad(false);
            } catch (error) {
                console.error('Error al descargar el archivo:', error);
            }
        });
    };

    const saveDireccion = (id) => {
        console.log(id);
        direcciones.cliente_Id = id;
        console.log(direcciones);
        if (!direcciones.hasOwnProperty('no_Direccion')) direcciones.no_Direccion = 'local';

        fetchConToken(
            `DireccionesClientes`,
            direcciones,
            direcciones.hasOwnProperty('id') && direcciones.id !== null ? 'PUT' : 'POST'
        ).then((response) => {
            setError(['']);
            setErroresV({});
            setErroresDirecciones('');
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');
                });
                setError('Revisar errores');
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            setDirecciones([]);
            setDirecciones(response);
            // direccion_id = response.id;
            guardarVenta(response.id);
            return true;
        });
        return true;
        //.catch(alertService.error("107"));
    };

    const guardarVenta = (id) => {
        console.log('entro guardar venta');
        venta.sucursal_Id = getDataSession('sucursal');
        venta.direccion_Id = id;
        if (venta.direccion_Id === 0) {
            Swal.fire('Error', 'Seleccione una direccion', 'error');
            return false;
        }

        if (ventaDetalles.length === 0) {
            Swal.fire('Error', 'Seleccione por los menos un articulo', 'error');
            return false;
        }

        if (venta.forma_De_Pago.length === 0 || !venta.hasOwnProperty('forma_De_Pago')) venta.forma_De_Pago = '01';

        if (venta.metodo_Pago.length === 0 || !venta.hasOwnProperty('metodo_Pago')) venta.metodo_Pago = 'PUE';

        if (venta.length === 0 || !venta.hasOwnProperty('moneda')) venta.moneda = 'MXN';

        venta.venta_Detalles = ventaDetalles;
        fetchConToken(
            `Ventas?sucursal_Id=${getDataSession('sucursal')}`,
            venta,
            venta.hasOwnProperty('id') && venta.id > 0 ? 'PUT' : 'POST'
        ).then((response) => {
            setErroresV({});
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');
                });
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            //alertService.success('Venta guardada', { keepAfterRouteChange: true });
            Swal.fire('Exito', 'Venta guardada', 'success');
            venta.id > 0 ? history.push('..') : history.push('.');
            setError('');
            setVenta(response);
            setVentaDetalles([]);
            setVentaDetalles(response.venta_Detalles);
            setFacturado(true);
            return true;
        });
        return true;
        //.catch(alertService.error("131"));
    };

    const facturar = () => {
        saveCliente();
    };

    const terminar = () => {
        Swal.fire({
            title: 'Terminar',
            text: "Desea terminar la venta",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Terminar!',
            cancelButtonText: 'No!'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchConToken(
                    `Ventas/Terminar?documento_id=${id}&sucursal_id=${getDataSession('sucursal')}`,
                    null, 'POST'
                ).then((response) => {
                    setErroresV({});
                    if (response.hasOwnProperty('status') && response.status === 400) {
                        Object.entries(response.errors).forEach(([, value]) => {
                            Swal.fire('Error', value[0], 'error');
                        });
                        return false;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return false;
                    }

                    Swal.fire('Exito', Docto + ' Terminada', 'success');
                    venta.id > 0 ? history.push('..') : history.push('.');
                    return true;
                });
            }
        });
    }

    React.useEffect(() => { if (ventaSucursalIdRef) ventaSucursalIdRef.current = venta.sucursal_Id; }, [venta.sucursal_Id]);

    React.useEffect(() => {
        async function getCliente(cliente_id) {
            const clienteAux = await fetchConToken(`Clientes?id=${cliente_id}&sucursal_Id=${ventaSucursalIdRef.current}`);
            clienteAux.regimen_Fiscal_Receptor = clienteAux.regimen_Fiscal_Receptor.replace(' ') === '' ? '601' : clienteAux.regimen_Fiscal_Receptor;
            clienteAux.uso_Cfdi = clienteAux.uso_Cfdi.replace(' ') === '' ? 'G01' : clienteAux.uso_Cfdi;
            clienteAux.estatus = clienteAux.estatus.replace(' ') === '' ? 'A' : clienteAux.estatus;
            clienteAux.rfc = clienteAux.estatus.replace(' ') === '' ? '' : clienteAux.rfc;
            setCliente(clienteAux);
            //console.log(clienteAux);
            //console.log(clienteAux.clientes_Direcciones[0]);
        }
        async function getDireccion(direccion_id) {
            const direccionAux = await fetchConToken(`DireccionesClientes?id=${direccion_id}`);
            setDirecciones(direccionAux);
            getCliente(direccionAux.cliente_Id);
        }
        async function getVenta() {
            const ventaAux = await fetchConToken(`Ventas?id=${id}&sucursal_Id=${getDataSession('sucursal')}`);
            ventaAux.forma_De_Pago = ventaAux.forma_De_Pago.replace(' ') === '' ? '01' : ventaAux.forma_De_Pago;
            ventaAux.metodo_Pago = ventaAux.metodo_Pago.replace(' ') === '' ? 'PUE' : ventaAux.metodo_Pago;
            setVenta(ventaAux);
            getDireccion(ventaAux.direccion_Id);
            setVentaDetalles(ventaAux.venta_Detalles);
            return ventaAux.venta_Detalles.filter(e => e.requiere_Revision === true).length > 0;
        }
        getSucursales();
        getSatFormaPago();
        getSatPais();
        getSeries(getDataSession('sucursal'));
        getVenta();
    }, [id]);

    // async function getCliente(cliente_id) {
    //     fetchConToken(`Clientes?id=${cliente_id}&sucursal_Id=${getDataSession('sucursal')}`).then(r => {
    //         if (r.hasOwnProperty('status') && r.status === 400) {
    //             Object.entries(r.errors).forEach(([, value]) => { Swal.fire('Error', value[0], 'error'); });
    //         }
    //         else if (r.hasOwnProperty('codigo') && r.codigo !== 200) {
    //             if (r.mensajes[0] !== "No se encontro el cliente") Swal.fire('Error', r.mensajes[0], 'error');
    //             else console.log(r.mensajes[0]);

    //             return;
    //         }

    //         const clienteAux = r;
    //         console.log(clienteAux);
    //         clienteAux.regimen_Fiscal_Receptor = clienteAux.regimen_Fiscal_Receptor.replace(' ') === '' ? '601' : clienteAux.regimen_Fiscal_Receptor;
    //         clienteAux.uso_Cfdi = clienteAux.uso_Cfdi.replace(' ') === '' ? 'G01' : clienteAux.uso_Cfdi;
    //         clienteAux.estatus = clienteAux.estatus.replace(' ') === '' ? 'A' : clienteAux.estatus;
    //         clienteAux.rfc = clienteAux.estatus.replace(' ') === '' ? '' : clienteAux.rfc;
    //         setCliente(clienteAux);
    //         setDirecciones(clienteAux.clientes_Direcciones[0]);
    //         venta.direccion_Id = clienteAux.clientes_Direcciones[0].id;
    //         console.log(clienteAux.clientes_Direcciones[0].id);
    //     });
    // }


    // async function getDireccion(direccion_id) {
    //     venta.direccion_Id = direccion_id;
    //     const direccionAux = await fetchConToken(`DireccionesClientes?id=${direccion_id}`);
    //     setDirecciones(direccionAux);
    //     getCliente(direccionAux.cliente_Id);
    // }

    const recargarVenta = async () => {
        const ventaAux = await fetchConToken(`Ventas?id=${id}&sucursal_Id=${getDataSession('sucursal')}`);
        ventaAux.forma_De_Pago = ventaAux.forma_De_Pago.replace(' ') === '' ? '01' : ventaAux.forma_De_Pago;
        ventaAux.metodo_Pago = ventaAux.metodo_Pago.replace(' ') === '' ? 'PUE' : ventaAux.metodo_Pago;
        setVenta(ventaAux);
        setVentaDetalles(ventaAux.venta_Detalles);
    };

    const { convertirRemision, SurtirRemisionPortal } = useSurtirRemision({
        onSuccess: recargarVenta,
        clienteNombre: cliente?.nombre,
        clienteRfc: cliente?.rfc,
    });

    const convertir = () => {
        if (TipoDocto === 'C') {
            Swal.fire({
                title: 'Convertir documento',
                text: `¿Desea convertir esta ${Docto.toLowerCase()} a pedido?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, convertir',
                cancelButtonText: 'No'
            }).then((result) => {
                if (!result.isConfirmed) return;

                fetchConToken(`Cotizaciones/ConvertirAPedido?documento_id=${id}&sucursal_id=${getDataSession('sucursal')}`, null, 'post').then(async (resp) => {
                    try {
                        if (resp.hasOwnProperty('status') && resp.status === 400) {
                            Object.entries(resp.errors).forEach(([, value]) => {
                                Swal.fire('Error', value[0], 'error');
                            });
                            return false;
                        } else if (resp.hasOwnProperty('codigo') && resp.codigo !== 200) {
                            Swal.fire('Error', resp.mensajes[0], 'error');
                            return false;
                        }
                        Swal.fire('Exito', 'El documento se convirtio correctamente', 'success');
                    } catch (error) {
                        console.error('Error al convertir el documento:', error);
                    }
                });
            });
            return;
        }

        if (TipoDocto === 'P') convertirRemision(id);
    }

    const puedeConvertirPedido = TipoDocto === 'P' && (venta.estatus === 'P' || venta.estatus === 'p');
    const puedeConvertirCotizacion = TipoDocto === 'C' && venta.estatus !== 'T' && venta.estatus !== 'C';

    return (<>
        <div className='container-fluid'>
            <TituloPagina descripcion={'#No.Orden: ' + venta?.no_Orden} />
            <TituloPagina descripcion={'#Folio: ' + venta?.folio} />
            <form onSubmit={handleSubmit(facturar)} className='facturar' /*onReset=""*/>
                <div className='col-md-12 text-right'>
                    <button
                        className='btn btn-outline-success'
                        onClick={(e) =>
                            descargarFactura(id, 'ventas/DescargarPDF', venta?.folio + '.pdf')
                        }
                        type='button'
                        disabled={load}
                    >
                        &nbsp; Descargar PDF
                    </button>
                    &nbsp;
                    {(puedeConvertirCotizacion || puedeConvertirPedido) ? <>
                        <button
                            className='btn btn-outline-success'
                            onClick={(e) => convertir()}
                            type='button'
                        >
                            &nbsp; Convertir a {TipoDocto === 'C' ? "Pedido" : "Remision"}
                        </button>
                        &nbsp;
                    </> : ""}
                    {venta.tipo_Documento === 'R' && getDataSession('tienda') === 'MERCADOLIBRE' ?
                        <button
                            className='btn btn-outline-success'
                            onClick={(e) => DescargarGuia()}
                            type='button'
                            disabled={load}
                        >
                            &nbsp; Descargar Guia
                        </button> : ''}
                    &nbsp;
                    {(venta.id > 0 && venta.folio_venta === null && venta.estatus !== 'C' && venta.estatus !== 'T') ? <>
                        <button
                            className='btn btn-outline-success'
                            onClick={(e) => terminar()}
                            type='button'
                        >
                            &nbsp; Terminar {Docto}
                        </button>
                        &nbsp;
                    </> : ""}
                    &nbsp;
                    <button
                        hidden={facturado || venta.estatus === 'CANCELADA' || venta.id === 0}
                        className='btn btn-outline-success'
                        onClick={(e) => cancelar()}
                        type='button'
                    >
                        &nbsp; Cancelar {Docto}
                    </button>
                    &nbsp;
                    <Link to={isAddMode ? '.' : '..'} className='btn btn-outline-warning'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='15'
                            height='15'
                            fill='currentColor'
                            className='bi bi-reply'
                            viewBox='0 0 16 16'
                        >
                            <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                        </svg>
                        &nbsp; Regresar
                    </Link>
                </div>
                <div className='espacio10px' />
                <div className='row'>
                    <div className='col-md-8'>
                        <div className='card mb-2 '>
                            <div className='card-title text-start'>
                                <h5><b>Detalles</b></h5>
                                <label>{venta.descripcion}</label>
                            </div>
                            {ventaDetalles.filter(i => i.cantidad > 0)?.map((item) => {
                                return (<>
                                    <hr style={{ border: "1px dotted black", width: "100%" }} />
                                    <div className='card-body text-start row'>
                                        <div className='col-md-4 col-sm-3 col-3'>{item.imagen === null ? <img src={sinImagen} width="100%" height="auto" alt='sin imagen' /> : <img src={item.imagen} width="100%" height="auto" alt='imagen' />}</div>
                                        <div className='col-md-6 col-sm-7 col-7'>
                                            <a href={SLUGS.articulos + "/edit/" + item.articulo_Id} target='_blank' rel="noreferrer">
                                                <b><p>{item.nombre_Articulo}</p></b>
                                                <p>{item.clave_Articulo} &emsp; {item?.clave_Variante}</p>
                                            </a>
                                            <div className='row'>
                                                <div className='col-md-7 col-sm-8 col-8 text-right'>
                                                    <p><small>Importe:</small></p>
                                                    <p><small>Impuesto:</small></p>
                                                    <p><small>SubTotal:</small></p>
                                                    <p><small>Utilidad:</small></p>
                                                </div>
                                                <div className='col-md-5 col-sm-4 col-4 text-right'>
                                                    <p><small>{currency(item.precio_Total)}</small></p>
                                                    <p><small>{currency(item.impuesto_Total)}</small></p>
                                                    <p><small>{currency(item.impuesto_Total + item.precio_Total)}</small></p>
                                                    <p><small>{currency(item.utilidad || 0)}</small></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-2 col-sm-2 col-2'><span>x{item.cantidad}</span></div>
                                    </div>
                                </>)
                            })}
                            <hr style={{ border: "1px dotted black", width: "100%" }} />
                            <div className='card-body text-start row'>
                                <div className='col-md-10 col-sm-8 col-8 text-right'>
                                    <b><p>Subtotal:</p></b>
                                    <b><p>IVA:</p></b>
                                    <b><p>Descuento:</p></b>
                                    <b><p>Total:</p></b>
                                    <b><p>Ganancia Aprox:</p></b>
                                </div>
                                <div className='col-md-2 col-sm-4 col-4 text-right'>
                                    <p>{currency(ventaDetalles.reduce((a, v) => (a = a + (v.precio_Unitario * v.cantidad)), 0))}</p>
                                    <p>{currency(ventaDetalles.reduce((a, v) => (a = a + v.impuesto_Total), 0))}</p>
                                    <p>{currency(venta?.descuento_Importe || 0)}</p>
                                    <p>{currency(ventaDetalles.reduce((a, v) => (a = a + v.precio_Total + v.impuesto_Total), 0) - (venta?.descuento_Importe || 0))}</p>
                                    <p>{currency(venta?.pago_Neto || 0)}</p>
                                </div>
                            </div>
                        </div>
                        <div className='card mb-2 '>
                            <div className='card-title text-start'><h5><b>Historial</b></h5></div>
                            <hr style={{ border: "1px dotted black", width: "100%" }} />
                            <div className='card-body text-start row'>
                                {venta.envios?.map(envio => {
                                    return (<><label>Guia: {envio.num_Guia}</label>
                                        <Stepper activeStep={true} orientation="vertical">
                                            {envio?.historial_Envio?.map(historial => {
                                                return (
                                                    <Step key={historial.id}>
                                                        <StepLabel
                                                            optional={
                                                                <label>{historial.estatus}</label>
                                                            }
                                                        >
                                                            {historial.fecha} --- {historial.subestatus}
                                                        </StepLabel>
                                                    </Step>)
                                            })}
                                        </Stepper></>)
                                })}
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='card mb-2 '>
                            <div className='card-title text-start'><h5><b>Cliente</b></h5></div>
                            <div className='card-body text-start row'>
                                <small>{cliente.nombre}</small>
                                <small>{cliente.no_Cliente}</small>
                                <small>{cliente.correo}</small>
                                <small>{cliente.rfc}</small>
                                <small>{cliente.telefono1}</small>
                                <small>{cliente.telefono2}</small>
                            </div>
                            <hr style={{ border: "1px dotted black", width: "100%" }} />
                            <div className='card-title text-start'><h5><b>Entrega</b></h5></div>
                            {venta.envios?.map(envio => {
                                return (<div className='card-body text-start row'>
                                    <div className='col-md-4'><small><b>Empresa:</b></small></div>
                                    <div className='col-md-8'><small>{envio.empresa_Envio}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Codigo Postal:</b></small></div>
                                    <div className='col-md-8'><small>{envio.codigo_Postal}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Num. Guia:</b></small></div>
                                    <div className='col-md-8'><small>{envio.num_Guia}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Direccion:</b></small></div>
                                    <div className='col-md-8'><small>
                                        {envio.pais}
                                        {envio.estado}
                                        {envio.ciudad}
                                        {envio.municipio}
                                        {envio.colonia}
                                        {envio.calle}
                                    </small>
                                    </div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Referencia:</b></small></div>
                                    <div className='col-md-8'><small>{envio.referencia}</small></div>
                                </div>)
                            })}
                            <hr style={{ border: "1px dotted black", width: "100%" }} />
                            <div className='card-title text-start'><h5><b>Pagos</b></h5></div>
                            {venta.pago_Ecommerce?.map(pago => {
                                return (<div className='card-body text-start row'>
                                    <div className='col-md-4'><small><b>Tipo Pago:</b></small></div>
                                    <div className='col-md-8'><small>{pago.tipo_pago}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Metodo Pago:</b></small></div>
                                    <div className='col-md-8'><small>{pago.metodo_pago}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Tipo Operacion:</b></small></div>
                                    <div className='col-md-8'><small>{pago.tipo_operacion}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>No. Pago:</b></small></div>
                                    <div className='col-md-8'><small>{pago.no_pago}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Fecha Pago:</b></small></div>
                                    <div className='col-md-8'><small>{pago.fecha_pago}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Fecha Aprov:</b></small></div>
                                    <div className='col-md-8'><small>{pago.fecha_aprovacion}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Monto:</b></small></div>
                                    <div className='col-md-8'><small>{currency(pago.monto)}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Costo Envio:</b></small></div>
                                    <div className='col-md-8'><small>{currency(pago.costo_envio)}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Tarifa Ecommerce:</b></small></div>
                                    <div className='col-md-8'><small>{currency(pago.tarifa_ecommerce)}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Estatus:</b></small></div>
                                    <div className='col-md-8'><small>{pago.estatus}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Detalle estatus:</b></small></div>
                                    <div className='col-md-8'><small>{pago.detalle_estatus}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Referencia Transf.:</b></small></div>
                                    <div className='col-md-8'><small>{pago.referencia_transferencia}</small></div>
                                    <hr />
                                    <div className='col-md-4'><small><b>Descripcion:</b></small></div>
                                    <div className='col-md-8'><small>{pago.descripcion}</small></div>
                                </div>)
                            })}
                        </div>
                    </div>
                </div>
                <br /><br /><br />
            </form>
        </div>
        <SurtirRemisionPortal />
    </>);
}

export { View }